export const LS_DEGREE_QUIZ_SUBMITTED = 'uc-dq-submitted';
export const LS_DEGREE_QUIZ_VERSION = 'uc-dq-version';
export const LS_DEGREE_QUIZ_ANSWERS = 'uc-dq-answers';
export const LS_DEGREE_QUIZ_UUID = 'uc-dq-uuid';
